import { render, staticRenderFns } from "./MappingInfoCard.vue?vue&type=template&id=983c9ae0&"
import script from "./MappingInfoCard.vue?vue&type=script&lang=js&"
export * from "./MappingInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports